import { normalizeHelperAppLocale, type HelperAppLocaleOption } from '../../services/helper/languageRegistryService'

export const HELPER_FIRST_RUN_LANGUAGE_PROMPT_DISMISSED_KEY = 'helper.firstRunLanguagePrompt.dismissedAt'

const readLocalStorage = (key: string): string | null => {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

const writeLocalStorage = (key: string, value: string): void => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // Storage can be unavailable in embedded/private contexts.
  }
}

export const hasDismissedHelperFirstRunLanguagePrompt = (): boolean =>
  Boolean(readLocalStorage(HELPER_FIRST_RUN_LANGUAGE_PROMPT_DISMISSED_KEY))

export const dismissHelperFirstRunLanguagePrompt = (timestamp = Date.now()): void => {
  writeLocalStorage(HELPER_FIRST_RUN_LANGUAGE_PROMPT_DISMISSED_KEY, new Date(timestamp).toISOString())
}

export const shouldShowHelperFirstRunLanguagePrompt = ({
  activeWorkspaceId,
  workspacesLoading,
  helperAppLocale,
  hasLocalPreference,
}: {
  activeWorkspaceId: string | null
  workspacesLoading: boolean
  helperAppLocale?: string | null
  hasLocalPreference: boolean
}): boolean => {
  if (!activeWorkspaceId || workspacesLoading) return false
  if (hasDismissedHelperFirstRunLanguagePrompt()) return false
  if (hasLocalPreference) return false
  return !helperAppLocale || helperAppLocale.trim().length === 0
}

export const getHelperFirstRunDefaultLocale = (workspaceLocale?: string | null) =>
  normalizeHelperAppLocale(workspaceLocale ?? 'en')

const INDIAN_LOCALE_CODES = new Set(['hi', 'bn', 'ta', 'te', 'mr', 'gu', 'ur', 'kn', 'or', 'ml'])

export const groupHelperFirstRunLanguageOptions = (options: HelperAppLocaleOption[]) => ({
  indian: options.filter((option) => INDIAN_LOCALE_CODES.has(option.code)),
  international: options.filter((option) => !INDIAN_LOCALE_CODES.has(option.code)),
})
